// Shared staff ward-assignment eligibility check, used anywhere a staff
// member is being assigned/considered for a shift by ward (WardWeeklyView
// drag-drop, StaffWeeklyView panel filtering, the person-icon availability
// filter). Mirrors the backend check in shiftController.js/wardScope.js —
// keep both in sync if this logic changes.
//
// Rules:
//  - If staff.onlyOwnWard is true: staff can ONLY be assigned to their own
//    Ward/Department Area (staff.speciality) or a ward listed in
//    staff.wardAreaInclusions (expects populated {_id, name} objects, as
//    returned by getAvailableStaff). This is a superset restriction and
//    overrides wardExclusions entirely.
//  - If staff.onlyOwnWard is false (default): staff are only blocked if the
//    ward appears in staff.wardExclusions.
//
// Returns { allowed: boolean, reason?: string } so callers can surface a
// consistent message via showSnackbar.
export const checkStaffWardEligibility = (staff, wardName) => {
  if (!staff) return { allowed: true };
  const ward = (wardName || '').toLowerCase();
  if (staff.onlyOwnWard) {
    const isOwnWard = ward === (staff.speciality || '').toLowerCase();
    const isIncludedWard = (staff.wardAreaInclusions || []).some(
      (loc) => (loc?.wardDepartmentArea || '').toLowerCase() === ward
    );
    if (!isOwnWard && !isIncludedWard) {
      return {
        allowed: false,
        reason: `${staff.name} can only be assigned to their own ward and cannot be assigned to this shift`,
      };
    }
    return { allowed: true };
  }
  const isExcluded = (staff.wardExclusions || []).some(
    (excludedWard) => excludedWard.toLowerCase() === ward
  );
  if (isExcluded) {
    return {
      allowed: false,
      reason: `${staff.name} is excluded from ${wardName} and cannot be assigned to this shift`,
    };
  }
  return { allowed: true };
};

// Convenience boolean-only version for filtering lists (panel filters,
// availability checks) where you don't need the rejection message.
export const isStaffAllowedForWard = (staff, wardName) =>
  checkStaffWardEligibility(staff, wardName).allowed;